module.exports = __webpack_public_path__ + "static/media/09_vozdobrasil.07558f05.jpg";